var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"copyRight"},[_vm._v(" Ⓒ Copyright 2021 www.fu-wong.com All rights reserved 百万富翁资讯网 版权所有 ")])}
var staticRenderFns = []

export { render, staticRenderFns }